module.exports = __webpack_public_path__ + "static/img/share_bg1.d0e026f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_bg1.png
// module id = kAx+
// module chunks = 1